import ResumeTimelineItem from "@/models/ui/TimelineItem";

export const experience = [
  new ResumeTimelineItem({
    name: 'Lead Frontend Web Developer',
    place: 'Experiencegift',
    date: 'December 2022 - present',
    link: 'https://www.experiencegift.com/',
    icon: require('../../assets/img/icons/experiencegift.svg'),
    description: ''
    // description: '<ul><li>Developed numerous interesting and complicated web applications and PWAs with Vue.js 2/3 (with Vuex), JavaScript, SCSS with API consumption.</li>' +
    //   '<li>Lead of a team of talented developers. Handled performance review meetings, hour logging checks, team-related issues. Utilised Jira and Confluence.</li>' +
    //   '<li>Lead of interesting projects. Handled agile ceremony meetings, Jira setup for development and clients, hour checking, some client communication. Made sure all developers knew what to do and the project is well-organised and within the estimation and deadline.</li>' +
    //   '<li>Proposed and implemented upgrades on a team and project level.</li>' +
    //   '<li>Internship/Traineeship applicants’ test code review and interviews with applicants (and HR).</li>' +
    //   '<li>Mentoring and supporting interns/trainees.</li>' +
    //   '<li>Pull request review.</li>' +
    //   '</ul>'
  }),
  new ResumeTimelineItem({
    name: 'Frontend Web Developer - Team Leader - Project Leader',
    place: 'DTT | apps web games',
    date: 'April 2020 - November 2022',
    // date: 'July 2021 - November 2022',
    link: 'https://www.d-tt.nl/',
    icon: require('../../assets/img/icons/dtt_logo_white.svg'),
    description: '<ul><li>Developed numerous interesting and complicated web applications and PWAs with Vue.js 2/3 (with Vuex), JavaScript, SCSS with API consumption.</li>' +
      '<li>Lead of a team of talented developers. Handled performance review meetings, hour logging checks, team-related issues. Utilised Jira and Confluence.</li>' +
      '<li>Lead of interesting projects. Handled agile ceremony meetings, Jira setup for development and clients, hour checking, some client communication. Made sure all developers knew what to do and the project is well-organised and within the estimation and deadline.</li>' +
      '<li>Proposed and implemented upgrades on a team and project level.</li>' +
      '<li>Internship/Traineeship applicants’ test code review and interviews with applicants (and HR).</li>' +
      '<li>Mentoring and supporting interns/trainees.</li>' +
      '<li>Pull request review.</li>' +
      '</ul>'
  }),
  // new ResumeTimelineItem({
  //   name: 'Frontend Web Developer - Project Leader',
  //   place: 'DTT | apps web games',
  //   date: 'April 2020 - July 2021',
  //   link: 'https://www.d-tt.nl/',
  //   icon: require('../../assets/img/icons/dtt_logo_white.svg'),
  // }),
  new ResumeTimelineItem({
    name: 'Frontend Web Developer Intern',
    place: 'DTT | apps web games',
    date: 'October 2019 - April 2020',
    link: 'https://www.d-tt.nl/',
    icon: require('../../assets/img/icons/dtt_logo_white.svg')
  }),
  new ResumeTimelineItem({
    name: 'Applied Informatics',
    place: 'University of Macedonia, Greece',
    date: 'September 2015 - September 2019',
    link: 'https://www.uom.gr/en/dai',
    icon: require('../../assets/img/icons/uom-logo-new-en.png')
  })


]
